import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SmoothScroll from "@/components/masar/SmoothScroll";
import AnnouncementBar from "@/components/masar/AnnouncementBar";
import Navbar from "@/components/masar/Navbar";
import Hero from "@/components/masar/Hero";
import EditorialMarquee from "@/components/masar/EditorialMarquee";
import HowItWorks from "@/components/masar/HowItWorks";
import Services from "@/components/masar/Services";
import Coverage from "@/components/masar/Coverage";
import Features from "@/components/masar/Features";
import CinematicBand from "@/components/masar/CinematicBand";
import Faq from "@/components/masar/Faq";
import Support from "@/components/masar/Support";
import PrivacySection from "@/components/masar/PrivacySection";
import Footer from "@/components/masar/Footer";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const t = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 220);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <SmoothScroll>
      <main className="relative min-h-screen bg-background text-foreground antialiased selection:bg-[#FF6A1A] selection:text-white grain">
        <AnnouncementBar />
        <Navbar />
        <CinematicBand />
        <EditorialMarquee />
        <HowItWorks />
        <Hero />
        <Services />
        <Coverage />
        <Features />
        <Faq />
        <Support />
        <PrivacySection />
        <Footer />
      </main>
    </SmoothScroll>
  );
}
